import { datadogRum } from "@datadog/browser-rum";

class LoggerService {
    logError(message: string) {
        datadogRum.addError(new Error(message));
    }
}

export const loggerService = new LoggerService();